import { Component, OnInit, OnDestroy, input, output, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { NgClass, NgStyle } from "@angular/common";
import { ClozeTestStyleModel } from "../model";

@Component({
  selector: "onset-cloze-test-introduction",
  templateUrl: "./introduction.component.html",
  standalone: true,
  styleUrls: ["./introduction.component.scss"],
  imports: [TranslatePipe, NgClass, NgStyle],
})
export class IntroductionComponent implements OnInit, OnDestroy {
  readonly route = inject(ActivatedRoute);
  readonly ngxTranslate = inject(TranslateService);
  readonly title = input("");
  readonly subtitle = input("");
  readonly content = input("");
  readonly clozeTestStyleModel = input({} as ClozeTestStyleModel);
  readonly cTestLogo = input("");
  readonly cTestButtonColor = input("");
  readonly mobileMode = input(false);
  readonly totalExercise = input(0);
  readonly currentExerciseNumber = input(0);

  readonly startTest = output<boolean>();
  readonly startTestExample = output<void>();

  readonly #subscription = new Subscription();

  ngOnDestroy(): void {
    this.#subscription.unsubscribe();
  }

  ngOnInit() {
    const langSub = this.route.queryParams.subscribe((params) => {
      if (params["lang"]) {
        const lang = params["lang"] as string;
        this.ngxTranslate.use(lang.toLowerCase());
      }
    });
    this.#subscription.add(langSub);
  }

  public toggleStartTest(): void {
    this.startTest.emit(true);
  }

  public toggleStartTestExample(): void {
    this.startTestExample.emit();
  }
}
